webpackJsonp([178011258625661],{

/***/ 472:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/bluetooth-printers-distribution/"},"frontmatter":{"title":"Bluetooth Printers Distribution"}}}]}},"pathContext":{"tag":"printer"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-printer-1a195ad1b4d7b5c13dba.js